
import { BasePageModel, basePageToLocal } from './base';
import { Reference, referenceNodeToLocal, referenceNodeToServer } from './parameter';

export enum StorageAnnotationInputType {
  Text = 'text',
  Dropdown = 'dropdown',
  Media = 'media'
}

export enum StorageAnnotationRelationship {
  None = '',
  OneToMany = 'one_to_many',
  ManyToOne = 'many_to_one'
}

export type FrameStorageAnnotation = BasePageModel & {
  uniqueKeys: Reference[][];
  enableView?: boolean;
  view?: string;
};

export type SlotStorageAnnotation = BasePageModel & {
  dataType: string;
  forUrl?: boolean;
  notNull: boolean;
  defaultValue: string;
  inputType: StorageAnnotationInputType;
  dropdown: string;
  hideInListView: boolean;
  readOnly: boolean;
  sortable: boolean;
  relationship: StorageAnnotationRelationship;
  masterSelf?: SlotStorageAnnotation;
};

export const DefaultSlotStorageAnnotation: SlotStorageAnnotation = {
  dataType: '',
  notNull: false,
  defaultValue: '',
  inputType: StorageAnnotationInputType.Text,
  dropdown: '',
  hideInListView: false,
  readOnly: false,
  sortable: false,
  relationship: StorageAnnotationRelationship.OneToMany
};

export const DefaultFrameStorageAnnotation: FrameStorageAnnotation = {
  uniqueKeys: [],
};

export function slotStorageAnnotationToLocal(res: any): SlotStorageAnnotation | undefined {
  if (!res) {
    return undefined;
  }

  return {
    ...basePageToLocal(res),
    dataType: res.data_type,
    forUrl: res.for_url,
    notNull: res.not_null,
    defaultValue: res.default_value,
    inputType: res.input_type,
    dropdown: res.dropdown,
    hideInListView: res.hide_in_list_view,
    readOnly: res.read_only,
    sortable: res.sortable,
    relationship: res.relationship,
    masterSelf: res.master_self
  };
}

export function slotStorageAnnotationToServer(data?: SlotStorageAnnotation): any {
  if (!data) {
    return undefined;
  }

  return {
    id: data.id,
    owner_id: data.ownerId,
    frame_id: data.frameId,
    data_type: data.dataType,
    for_url: data.forUrl,
    not_null: data.notNull,
    default_value: data.defaultValue,
    input_type: data.inputType,
    dropdown: data.dropdown,
    hide_in_list_view: data.hideInListView,
    read_only: data.readOnly,
    sortable: data.sortable,
    relationship: data.relationship
  };
}

export function frameStorageAnnotationToLocal(res: any): FrameStorageAnnotation | undefined {
  if (!res) {
    return undefined;
  }

  return {
    ...basePageToLocal(res),
    uniqueKeys: res && (res.unique_keys || [])
      .map((key: any[]) =>
        key.map((ref: any) =>
          ref.map(referenceNodeToLocal)
        )
      ) || [],
    enableView: res.enable_view,
    view: res.view
  };
}

export function frameStorageAnnotationToServer(data?: FrameStorageAnnotation): any {
  if (!data) {
    return undefined;
  }

  return {
    id: data.id,
    owner_id: data.ownerId,
    frame_id: data.frameId,
    unique_keys: data && (data.uniqueKeys || [])
      .map((key: Reference[]) =>
        key.map((ref: Reference) =>
          ref.map(referenceNodeToServer)
        )
      ),
    enable_view: data.enableView,
    view: data.view
  };
}

